import { render, staticRenderFns } from "./WebinarNew.vue?vue&type=template&id=2580b5e4&"
import script from "./WebinarNew.vue?vue&type=script&lang=ts&"
export * from "./WebinarNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports